export default __webpack_public_path__ + "static/media/HotTopic_Background.1e739720.svg";